import React from "react";
import { Card, CardHeader, CardText } from "material-ui/Card";
import { List, ListItem } from "material-ui/List";
import EliminatedIcon from "material-ui/svg-icons/action/highlight-off";
import CaveatIcon from "material-ui/svg-icons/action/feedback";
import caveatColor from "../caveatColor";
import { getResponse } from "../reducer/response";
import { connect } from "react-redux";
import { answerTextLookup, effectOnOptions } from "../reducer/response";
import {SECTION_TITLES} from "../containers/AnswersList";
import {IntlProvider} from 'react-intl';
import {FormattedMessage, injectIntl} from "react-intl";
import {getTranslationMessages} from "../reducer/translations"

function AnswerInfluenceCard({
  question,
  answer,
  initiallyExpanded,
  effect,
  section,
  categories,
  intl,
  response
}) {
  let { options } = effect;
  if (section) {
    options = options.filter((o) => o.section === section);
  }

  let trIDForResponse = (response && response.userEdits) ? response.userEdits.trIDForResponse : -1;
  let messages = getTranslationMessages(trIDForResponse)

  var title = intl.formatMessage({id:"answerModal.impact", defaultMessage: "This answer impacts {numImpacted, plural, one {# option } other {# options }}"}, {numImpacted: options.length})
  title = section ? title + intl.formatMessage({id:"answerModal.inSection", defaultMessage: "in this section"}) : title + intl.formatMessage({id:"answerModal.inTotal", defaultMessage: "in total"})

  return (
    <IntlProvider locale="en" defaultLocale="en" messages={messages}> {/*TODO: why is this not being covered by the IntlProvider in routes?*/}
      <Card
        style={{ width: "85%", margin: "0 auto" }}
        initiallyExpanded={initiallyExpanded}
      >
        <CardHeader
          title={title}
          actAsExpander={true}
          showExpandableButton={true}
          open={true}
        />
        <CardText expandable={true}>
          <List>
            {options.map(option => (
              <ListItem
                key={option.id + option.title + "li" + (option.caveat ? option.caveat.title : "criteria")}
                primaryText={categories[option.category] + " - " + option.title}
                secondaryTextLines={2}
                secondaryText={
                  option.eliminated
                    ? "Eliminated by this answer"
                    : "Caveat - " + option.caveat.title
                }
                leftAvatar={
                  option.eliminated ? (
                    <EliminatedIcon color="red" />
                  ) : (
                    <CaveatIcon
                      color={caveatColor(option.caveat.score).primary}
                    />
                  )
                }
                disabled={true}
              />
            ))}
          </List>
        </CardText>
      </Card>
    </IntlProvider>
  );
}

let mapStateToProps = (state, ownProps) => {
  let response = getResponse(state);
  return {
    questions: state.questions,
    answerTextLookup: answerTextLookup(state),
    effect: effectOnOptions(
      state,
      ownProps.question.id,
      true,
      response,
      ownProps.answer ? ownProps.answer.value : null,
      ownProps.section
    ),
    categories: state.categories.reduce((lookup, c) => {
      lookup[c.id] = c.title;
      return lookup;
    }, {}),
    response: response
  };
};

export default connect(mapStateToProps)(injectIntl(AnswerInfluenceCard));
